export class Utils {
    static randomNumber(a, b){
        return Math.floor(Math.random() * (b - a) + a);
    }
}